import { Observable } from 'rxjs'
import { participantTypes, authTypes, generalTypes } from '../actions'
import { apiUrl } from '../config/settings'
import { push } from 'react-router-redux'
import { Headers, Auth } from '../helpers'

export const getEpic = (action$) => {
  return action$.ofType(participantTypes.GET)
    .switchMap(({ id }) => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/participants/${id}`,
            method: 'GET',
            headers: Headers.getWithAuth()
          }
        )
        .map(res => ({ type: participantTypes.GET_RESPONSE, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const getResponseEpic = (action$) => {
  return action$.ofType(participantTypes.GET_RESPONSE)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            const { participant } = action.payload
            if (participant.id === Auth.getParticipant()) {
              let user = Auth.getUser()
              user.name = participant.name
              user.avatar = participant.avatar
              user.handle = participant.handle

              const token = Auth.getToken()

              Auth.authenticateUser(token, user)
              obs.next({ type: authTypes.SUCCESS, user: user })
              obs.next(push(`/player/${participant.id}`))
            }

            obs.next({ type: participantTypes.UPDATE, participant })
          } else {
            obs.next({ type: generalTypes.DISPLAY_ALERT, text: action.payload.err.message })
          }
          obs.complete()
        })
        .catch(err => window.alert(err))
    })
}

export const manageProfileEpic = (action$) => {
  return action$.ofType(participantTypes.MANAGE)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/participants/manage`,
            method: 'POST',
            headers: Headers.getWithAuth(),
            body: action.data
          }
        )
        .map(res => ({ type: participantTypes.GET_RESPONSE, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const changeAttendingStatusEpic = (action$) => {
  return action$.ofType(participantTypes.CHANGE_STATUS)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/admin/change`,
            method: 'POST',
            headers: Headers.getWithAuth(),
            body: action.data
          }
        )
        .map(res => ({ type: participantTypes.GET_RESPONSE, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const changeCommentEpic = (action$) => {
  return action$.ofType(participantTypes.CHANGE_COMMENT)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/admin/changecomment`,
            method: 'POST',
            headers: Headers.getWithAuth(),
            body: action.data
          }
        )
        .map(res => ({ type: participantTypes.GET_RESPONSE, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const changeLocationEpic = (action$) => {
  return action$.ofType(participantTypes.CHANGE_LOCATION)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/admin/location/${action.city}`,
            method: 'GET',
            headers: Headers.getWithAuth()
          }
        )
        .map(res => ({ type: participantTypes.CHANGE_LOCATION_RES, payload: res.response }))
        .catch(err => window.alert(err))
    })
}

export const changeLocationResEpic = (action$) => {
  return action$.ofType(participantTypes.CHANGE_LOCATION_RES)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            obs.next({ type: generalTypes.DISPLAY_ALERT, text: 'Location changed. Please reload the page.' })
          } else {
            obs.next({ type: generalTypes.DISPLAY_ALERT, text: action.payload.err.message })
          }
          obs.complete()
        })
        .catch(err => window.alert(err))
    })
}



// WEBPACK FOOTER //
// ./src/epics/participants.js